import React from "react";
import { ColorValue, Platform, View } from "react-native";

type Props = {
    height?: number;
    bgColor?: ColorValue;
    blurrEffect?: boolean;
}
const AppleStatusBarPadding: React.FC<Props> = ({ bgColor, height = 50, blurrEffect }) => {

    const shouldShow = window.navigator.userAgent.includes("iPhone") &&
        window.navigator.userAgent.includes("PWAShell");

    return <>
        {shouldShow && <View style={{
            backgroundColor: bgColor || "transparent",
            height,
            width: "100%",
            backdropFilter: blurrEffect ? "blur(20px)" : undefined,
        }}>
        </View>}
    </>;
};

export default AppleStatusBarPadding;
